export default __webpack_public_path__ + "static/media/berg_logo-black.3cdc307e.svg";